var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer mt-5", attrs: { id: "footer" } },
    [
      _c("div", { staticClass: "footer-background-container" }, [
        _c("img", {
          staticClass: "footer-background",
          class: { cropped: !_vm.isHomepage },
          attrs: {
            src: "/content/images/footer_pozadina.png",
            alt: "Footer background",
          },
        }),
      ]),
      _vm._v(" "),
      _c("b-container", { staticClass: "mb-3", attrs: { fluid: "lg" } }, [
        _c("div", { staticClass: "partnersFooter" }, [
          _c(
            "a",
            { attrs: { href: "https://nitra.gov.rs/cir", target: "_blank" } },
            [
              _c("img", {
                attrs: {
                  src: "/content/images/logo-nitra.png",
                  alt:
                    "Ministarstvo nauke, tehnoološkog razvoja i inovacija logo",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "https://euprava.gov.rs/", target: "_blank" } },
            [
              _c("img", {
                attrs: {
                  src: "/content/images/logo-euprava.png",
                  alt: "eUprava logo",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.pmi.com/markets/serbia/rs/about-us/overview",
                target: "_blank",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: "/content/images/morris.png",
                  alt: "Phillip Morris logo",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("a", { attrs: { href: "https://naled.rs/", target: "_blank" } }, [
            _c("img", {
              attrs: { src: "/content/images/naled.png", alt: "NALED logo" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: "https://www.startech.org.rs/", target: "_blank" },
            },
            [
              _c("img", {
                attrs: {
                  src: "/content/images/startech-logo.png",
                  alt: "Startech logo",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "https://www.undp.org/", target: "_blank" } },
            [
              _c("img", {
                attrs: {
                  src: "/content/images/undp-logo-blue.png",
                  alt: "UNDP logo",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.worldbank.org/en/home",
                target: "_blank",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: "/content/images/logo-world-bank.png",
                  alt: "The World Band Group logo",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://cubeteam.com/sr/naslovna",
                target: "_blank",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: "/content/images/cube_logo.png",
                  alt: "CUBE Team logo",
                },
              }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "lg" } },
        [
          _c("b-row"),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass:
                "d-flex align-items-center justify-content-around footerLinks",
            },
            [
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    { staticClass: "text-body link", attrs: { to: "/about" } },
                    [
                      _c(
                        "span",
                        { staticClass: "font-weight-normal text-white" },
                        [_vm._v(_vm._s(_vm.$t("footer.about")))]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "text-body link",
                      attrs: { to: "/contact" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "font-weight-normal text-white" },
                        [_vm._v(_vm._s(_vm.$t("footer.contact")))]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "text-body link",
                      attrs: { to: "/privacy-policy" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "font-weight-normal text-white" },
                        [_vm._v(_vm._s(_vm.$t("footer.privacy")))]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "text-body link",
                      attrs: { to: "/cookie-policy" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "font-weight-normal text-white" },
                        [_vm._v(_vm._s(_vm.$t("footer.cookie")))]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "text-body link",
                      attrs: { to: "/terms-of-use" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "font-weight-normal text-white" },
                        [_vm._v(_vm._s(_vm.$t("footer.terms")))]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "text-body link",
                    attrs: {
                      href:
                        "https://docs.google.com/document/d/11p8v6pQ4kd4Fx5oxexPuMiQbytybSUKQVIxR6fN9yFU/edit?tab=t.0",
                      target: "_blank",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "font-weight-normal text-white" },
                      [_vm._v(_vm._s(_vm.$t("footer.instructions")))]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }